import { makeAutoObservable, reaction } from 'mobx';
import userStore from './userStore';
import apiService from 'Service'
import authStore from './authStore'
import companyStore from './companyStore'
import { API_URL } from 'config/env'

class membershipsStore {
  currentMembership = undefined
  membership = {}
  isLoading = false
  serviceUrl = API_URL.replace(/\/$/, '')

  constructor() {
    makeAutoObservable(this)
    this.loadFromLocalStorage()
    reaction(
      () => this.currentMembership,
      currentMembership => {
        if (currentMembership) {
          let data = JSON.stringify(currentMembership);
          localStorage.setItem('currentMembership', data);
        } else {
          localStorage.removeItem('currentMembership');
        }
      }
    )
  }

    loadFromLocalStorage(){
      try {
        this.currentMembership = JSON.parse(localStorage.getItem('currentMembership'))
        if(this.currentMembership !== null && this.currentMembership !== undefined){
          this.setServiceUrl(this.currentMembership.RouteWebService)
        }
      } catch (e) {
        authStore.logout()
      }
    }

    setCurrentMembership(membership){
      this.currentMembership = membership
      this.setServiceUrl(this.currentMembership.RouteWebService)
    }

    updateLocalMembershipState(data){
      this.membership = {
        ...this.membership,
        ...data
      }
    }

    initProcess(defaultValues){
      this.membership = { ...defaultValues, EMail: userStore.currentUser.EMail }
    }

    sendDemoRequest(){
      this.isLoading = true
      return apiService.Account.activeDemo(this.membership).then(data => {
        companyStore.setOwnCompanies(data.OwnerCompanies)
      }).finally(() => this.isLoading = false)
    }

    sendNewMembershipRequest(){
      this.isLoading = true
      const payload = {
        KeyMembership: this.currentMembership?.Keymembership,
        Name: this.membership.Name,
        RIF: this.membership.RIF,
        FiscalAddress: this.membership.FiscalAddress,
        Address: this.membership.Address,
        Phone: this.membership.Phone,
        Celular: this.membership.Celular,
        PeopleContact: this.membership.PeopleContact,
      }
      return apiService.Account.createCompany(payload).then(company => {
        if (company && this.currentMembership) {
          const nextCompanies = [...(this.currentMembership.Companies || []), company]
          const active = nextCompanies.length
          const max = this.currentMembership.MaxCompanies ?? active
          const updatedMembership = {
            ...this.currentMembership,
            Companies: nextCompanies,
            ActiveCompanies: active,
            CanAddCompany: active < max,
          }
          this.currentMembership = updatedMembership
          companyStore.setOwnCompanies(companyStore.ownCompanies.map(m =>
            m.Keymembership === updatedMembership.Keymembership ? updatedMembership : m
          ))
        }
        return company
      }).finally(() => this.isLoading = false)
    }

    forgetAll(){
      this.currentMembership = undefined
      this.serviceUrl = API_URL.replace(/\/$/, '')
    }

    setServiceUrl(_legacyRouteWebService) {
      // API Core unificada vía VITE_API_URL; RouteWebService por membresía queda obsoleto.
      this.serviceUrl = API_URL.replace(/\/$/, '')
    }
  }

export default new membershipsStore();
